import React from 'react';
const ArrowLeftIcon = ({ fill, width, height, opacity }) => (
    <svg width={width} height={height} viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path d="M0 0h20v20H0z" />
            <path
                fill={fill}
                opacity={opacity}
                d="M11.656 17.607a.998.998 0 0 0 1.415 0c.39-.39.387-1.027 0-1.415L6.827 9.951l6.242-6.242a1.003 1.003 0 0 0 .001-1.415.998.998 0 0 0-1.415 0L4 9.951l7.656 7.656z"
            />
        </g>
    </svg>
);

export default ArrowLeftIcon;
